var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTickButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "url(#paint0_linear_6916_7854)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 20.75L18.455 23.75L25.0026 16.25",
    stroke: "#FAFDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6916_7854",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#799DD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTickButton);
export default __webpack_public_path__ + "static/media/EditTickButton.79a4e8e076d54a143d61e66e7b4da4a2.svg";
export { ForwardRef as ReactComponent };